import React from 'react';

const IconWrapper = ({ color, size = '60px', children, ...rest }) =>
  React.cloneElement(children, {
    width: size,
    height: size,
    ...(color && { fill: color }),
    ...rest,
  });

export default IconWrapper;
